<template>
    <div class="init" style="display:hidden">
    </div>
</template>
<script>

export default{
	mounted(){
		this.$nextTick(
			()=>
			{
				require('@/assets/js/core/bootstrap.min.js')
				require('@/assets/js/plugins/fontawesomekit.js')
				require('@/assets/js/soft-ui-dashboard.js')
			}
		)

	},
	data:()=>({
		thisDay:0,
	}),
	computed:{
	},
	methods:{
	}
}


</script>